//função que valida se a empresa enviou um declínio para aquela ordem de serviço
export function isRefuseByEmpresa(ordemServico, idEmpresa) {
  return ordemServico.ordensServicosOrcamentos?.some(orcamento => orcamento.idEmpresa == idEmpresa && orcamento.declinio == true);
}
